import React from 'react';
import SendVerificationCode from "../../components/Buttons/SendVerificationCode.jsx";
import TryAgainFooterButtons from "../../components/Buttons/TryAgainFooterButtons.jsx";

export function RegistrationButtons({
  isDisplayed,
  error,
  onBeginRecaptchaValidation,
  isProcessing,
  beginRecaptchaValidationState
}) {
  if (!isDisplayed) {
    return null;
  }

  if (!error) {
    return (
      <SendVerificationCode 
        confirm={onBeginRecaptchaValidation} 
        disabled={beginRecaptchaValidationState !== undefined || isProcessing}
      />
    );
  } else {
    return (
      <TryAgainFooterButtons 
        confirm={onBeginRecaptchaValidation} 
        isProcessing={isProcessing} 
        disabled={beginRecaptchaValidationState !== undefined}
      />
    );
  }
} 